// extracted by mini-css-extract-plugin
module.exports = {"wholehome":"WholeHome_wholehome__QfNud"};